import { Routes } from '@angular/router';
import { LoginwebappComponent } from './loginwebapp/loginwebapp.component';
import { ErrorComponent } from './loginwebapp/error/error.component';
import { PageNotFoundComponent } from './loginwebapp/page-not-found/page-not-found.component';

export const routes: Routes = [
  {
    path: '',
    component: LoginwebappComponent,
    children: [
      {
        path: 'loginwebapp',
        loadChildren: () => import('./loginwebapp/loginwebapp.routes').then(m => m.LOGINWEBAPP_ROUTES)
      }
    ]
  },
  { path: 'error', component: ErrorComponent },
  { path: '**', component: PageNotFoundComponent }
];
